import { render, staticRenderFns } from "./CheckoutNewOrderSideBar.vue?vue&type=template&id=3320d0a0&scoped=true&"
import script from "./CheckoutNewOrderSideBar.vue?vue&type=script&lang=js&"
export * from "./CheckoutNewOrderSideBar.vue?vue&type=script&lang=js&"
import style0 from "./CheckoutNewOrderSideBar.vue?vue&type=style&index=0&id=3320d0a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3320d0a0",
  null
  
)

export default component.exports